import React, { useMemo } from 'react'

import DrillDownFilter from '~/client/src/shared/components/DrillDownFilter'
import { IDrillDownFilterCategory } from '~/client/src/shared/components/DrillDownFilter/DrillDownFilter.types'
import { ListHeader } from '~/client/src/shared/components/ListHeader'
import { TagType } from '~/client/src/shared/enums/TagType'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { ITag } from '~/client/src/shared/models/Tag'
import { getBandTitleByTagType } from '~/client/src/shared/utils/TagHelper'

interface IProps {
  tagsByType: Partial<Record<TagType, ITag[]>>
  // The categories offered, in order. The owner's tag matcher must use the
  // same list, so there is no default to drift from.
  tagTypes: TagType[]
  appliedTagIds: string[]
  onApplyFilters: (tagIds: string[]) => void
}

export const USER_TAG_TYPES: TagType[] = [
  TagType.Company,
  TagType.GlobalAndProjectSpecificRole,
  TagType.Team,
  TagType.Trade,
  TagType.AccountPosition,
  TagType.AccountType,
  TagType.UserTag,
]

const UserListFilters: React.FC<IProps> = ({
  tagsByType,
  tagTypes,
  appliedTagIds,
  onApplyFilters,
}) => {
  const categories = useMemo(
    (): IDrillDownFilterCategory<ITag>[] =>
      tagTypes
        .filter(type => tagsByType[type]?.length)
        .map(type => ({
          id: type,
          label: getBandTitleByTagType(type),
          items: tagsByType[type] || [],
          getItemId: (tag: ITag) => tag.id,
          getItemLabel: (tag: ITag) => tag.name,
        })),
    [tagsByType, tagTypes],
  )

  if (categories.length === 0) return null

  return (
    <ListHeader.Filter badgeCount={appliedTagIds.length}>
      <DrillDownFilter.Platform
        title={Localization.translator.filterBy}
        categories={categories}
        initialSelection={appliedTagIds}
        onApply={onApplyFilters}
      />
    </ListHeader.Filter>
  )
}

export default UserListFilters
